// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-login-by-id {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.dl-login-by-id_view_primary {
  color: var(--g-color-text-primary);
}
.dl-login-by-id_view_secondary {
  color: var(--g-color-text-secondary);
}
.dl-login-by-id_view_light-primary {
  color: var(--g-color-text-light-primary);
}
.dl-login-by-id__skeleton {
  vertical-align: middle;
  width: 80px;
  height: 12px;
}`, "",{"version":3,"sources":["webpack://./src/ui/units/auth/components/LoginById/LoginById.scss","webpack://./node_modules/@gravity-ui/uikit/styles/mixins.scss"],"names":[],"mappings":"AAEA;ECEI,mBAAA;EACA,gBAAA;EACA,uBAH4B;ADChC;AACI;EACI,kCAAA;AACR;AAEI;EACI,oCAAA;AAAR;AAGI;EACI,wCAAA;AADR;AAII;EACI,sBAAA;EACA,WAAA;EACA,YAAA;AAFR","sourcesContent":[".dl-login-by-id {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.dl-login-by-id_view_primary {\n  color: var(--g-color-text-primary);\n}\n.dl-login-by-id_view_secondary {\n  color: var(--g-color-text-secondary);\n}\n.dl-login-by-id_view_light-primary {\n  color: var(--g-color-text-light-primary);\n}\n.dl-login-by-id__skeleton {\n  vertical-align: middle;\n  width: 80px;\n  height: 12px;\n}",null],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
